export default __webpack_public_path__ + "./images/payPal.b7c67b29.svg";